import {
  loadingConversations,
  setConversations,
  setConversationsCount,
  loadingChats,
  setChats,
  setAgentStartedConversations,
} from './conversations.actions';
import {
  handleFetchConversations,
  handleFetchAgentStartedConversations,
  handleFetchLongTermChats,
  handleFetchShortTermChats,
} from './conversations.helpers';
import conversationTypes from './conversations.types';
import { all, call, put, takeLatest, select } from '@redux-saga/core/effects';
import { handleErrors } from '../../utils';
import { createConversationsObject } from './conversations.adapter';
import moment from 'jalali-moment';

const mapState = ({ appData }) => ({
  locale: appData.locale,
});

export function* fetchAgentStartedConversations({ payload }) {
  const { startDate, endDate, channelId } = payload;
  const { locale } = yield select(mapState);
  try {
    const responseData = yield handleFetchAgentStartedConversations(
      startDate && startDate,
      endDate ? endDate : moment().format(`YYYY-MM-DD`),
      channelId
    );
    yield put(setAgentStartedConversations(responseData?.count));
  } catch (error) {
    handleErrors(error, locale);
  }
}

export function* fetchConversations({ payload }) {
  const { locale } = yield select(mapState);
  try {
    const { startDate, endDate, isLastWeek, channelId } = payload;
    yield put(loadingConversations());
    const responseData = yield handleFetchConversations(
      startDate && startDate,
      endDate && endDate,
      channelId
    );
    yield put(setConversations(createConversationsObject(responseData)));
    let conversationsCount = {
      all: {
        ...responseData.all,
      },
      lastWeek: {
        count: 0,
      },
    };
    if (isLastWeek) {
      conversationsCount.lastWeek = {
        count: responseData.chart.all,
      };
    }
    yield put(setConversationsCount(conversationsCount));
  } catch (error) {
    handleErrors(error, locale);
  }
}

export function* fetchShortTermMessages(start, end, channelId) {
  const { locale } = yield select(mapState);
  try {
    yield put(loadingChats(true));

    const res = yield handleFetchShortTermChats(
      start && start,
      end && end,
      channelId && channelId
    );

    yield put(setChats(res, 'ready'));
  } catch (error) {
    // Invalid range.
    if (error?.response?.status === 400) {
      yield fetchLongTermMessages(
        start && start,
        end && end,
        channelId && channelId
      );
      return;
    }

    handleErrors(error, locale);
  }
}

export function* fetchLongTermMessages(start, end, channelId) {
  const { locale } = yield select(mapState);
  try {
    yield put(loadingChats(true));
    const res = yield handleFetchLongTermChats(
      start && start,
      end && end,
      channelId && channelId
    );
    if (res === 'Computing') yield put(setChats([], 'waiting'));
    else yield put(setChats(res, 'ready'));
  } catch (error) {
    // data not found
    if (error?.response?.status === 404) {
      yield put(setChats([], 'none'));
      return;
    }
    handleErrors(error, locale);
  } finally {
    yield put(loadingChats(false));
  }
}

export function* fetchAllMessages({ payload }) {
  const { startDate, endDate, id } = payload;

  const start = moment(startDate);
  const end = moment(endDate);

  if (end.diff(start, 'days') < 30)
    yield fetchShortTermMessages(
      startDate && startDate,
      endDate && endDate,
      id && id
    );
  else
    yield fetchLongTermMessages(
      startDate && startDate,
      endDate && endDate,
      id && id
    );
}

export function* onFetchConversationsStart() {
  yield takeLatest(
    conversationTypes.FETCH_CONVERSATIONS_START,
    fetchConversations
  );
  yield takeLatest(
    conversationTypes.FETCH_CONVERSATIONS_START,
    fetchAgentStartedConversations
  );
}

export function* onFetchMessages() {
  yield takeLatest(conversationTypes.FETCH_CHATS_START, fetchAllMessages);
}

export default function* conversationsSagas() {
  yield all([call(onFetchConversationsStart), call(onFetchMessages)]);
}
